
/* injects from baggage-loader */

import Helpers from "../helperFunctions";

export const getAllRegionsFromSportsList = (sportsList) => {
    const notEmptySports = sportsList.filter(sport => Object.keys(sport.region).length)
    const allRegions = []

    for (const sport of notEmptySports) {
        allRegions.push(...Helpers.objectToArray(sport.region))
    }

    return allRegions.sort((a, b) =>  a.order - b.order)
}

export const getRegionListSubscriptionData = (swarmData, gameType, sportAlias) => {
    let result = {},
        gamesCount = 0;

    if (sportAlias !== "all") {
        const data = swarmData[0].region
        result.regionIds = Helpers.objectToArray(data).sort((a, b) => a.order - b.order).map((region) => region.id);
        data[result.regionIds[0]] && Helpers.objectToArray(data[result.regionIds[0]].competition).forEach(comp => { gamesCount += comp.game; });

        if (gameType !== "live" && (gamesCount > 80)) {
            result.competitionId = Helpers.objectToArray(data[result.regionIds[0]].competition).sort((a, b) => a.order - b.order)[0].id;
        }
    } else {
        const notEmptySports = swarmData.filter(sport => Object.keys(sport.region).length)
        const allRegions = []

        for (const sport of notEmptySports) {
            const sportRegions = Helpers.objectToArray(sport.region)
            for (const region of sportRegions) {
                if (allRegions.findIndex(el => el.alias === region.alias) === -1)  {
                    delete region.competition
                    allRegions.push(region)
                }
            }
        }

        allRegions.sort((a, b) =>  a.order - b.order)
        result.regionIds = allRegions.map(region => region.id)
    }
    // Automatically select Competition if the Region Competition count is more than 80
    
    return result;
};